const SEPARADOR_PARTES_JWT = ".";
const CANTIDAD_PARTES_JWT = 3;
const INDICE_PAYLOAD = 1;
const BASE64_RELLENO = "=";
const MULTIPLO_BASE64 = 4;

/**
 * Lee el payload de un JWT para mostrar datos de perfil (nombre, correo) en pantalla.
 *
 * ⚠️ Consideración de seguridad: NO verifica la firma. La validez del token la garantiza
 * msal al emitirlo; este resultado jamás debe usarse para autorizar ni para decidir permisos.
 *
 * @param {string} token JWT con formato cabecera.payload.firma
 * @returns {object|null} el payload, o null si el token no tiene un formato decodificable
 */
export function decodificarPayloadJwt(token) {
  const partes = typeof token === "string" ? token.split(SEPARADOR_PARTES_JWT) : [];
  if (partes.length !== CANTIDAD_PARTES_JWT) return null;

  try {
    return JSON.parse(decodificarBase64Url(partes[INDICE_PAYLOAD]));
  } catch (error) {
    if (esErrorDeFormatoInvalido(error)) return null;
    throw error;
  }
}

// atob solo entiende base64 estándar; JWT usa la variante URL-safe y omite el relleno.
function decodificarBase64Url(textoBase64Url) {
  const base64 = textoBase64Url.replace(/-/g, "+").replace(/_/g, "/");
  const faltantes = (MULTIPLO_BASE64 - (base64.length % MULTIPLO_BASE64)) % MULTIPLO_BASE64;
  const binario = atob(base64 + BASE64_RELLENO.repeat(faltantes));

  // atob devuelve bytes; se reinterpretan como UTF-8 para conservar tildes y la ñ.
  const bytesComoPorcentaje = Array.from(
    binario,
    (caracter) => "%" + caracter.charCodeAt(0).toString(16).padStart(2, "0")
  ).join("");
  return decodeURIComponent(bytesComoPorcentaje);
}

// Solo se tratan como "token inválido" los errores esperados; cualquier otro se propaga.
function esErrorDeFormatoInvalido(error) {
  return (
    error instanceof SyntaxError ||
    error instanceof URIError ||
    error.name === "InvalidCharacterError"
  );
}
